import { FC } from "react";
import "../../../styles/components.css";

interface PropertiesMenuProps {
  propertiesPanelReveal: boolean;
}

export const PropertiesMenu: FC<PropertiesMenuProps> = ({
  propertiesPanelReveal,
}) => {
  if (!propertiesPanelReveal) return <></>;

  return (
    <div id="propertiesMenu">
      <div id="propertiesWrapper">
        <bim-panel>
          <bim-panel-section
            name="properties"
            label="Properties Information"
            icon="solar:document-bold"
            fixed
          ></bim-panel-section>
        </bim-panel>
      </div>
    </div>
  );
};

export default PropertiesMenu;
